export default __webpack_public_path__ + "static/media/14.b186c6fe.jpeg";